export default "__VITE_ASSET__wM7g9xI2__"